import { Api } from '@shared/constants/common-field.constants';
import { IPlatformApiProvider } from '@shared/services/platform-api-provider';

export class GmtApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.includes('/gmt/analytics/report-view')) {
      return Api.FileStoreApi;
    } else if (url.includes('/gmt/analytics')) {
      return Api.Visualizer;
    } else if (url.includes('/gmt/library/taxnews')) {
      return Api.TaxNews;
    } else if (url.includes('/gmt/scenarios/otp')) {
      return Api.FileStoreApi;
    } else if(url.includes('/gmt/scenarios/pillar2-compliance-analytic')){
      return Api.FileStoreApi
    } else if(url.includes('/gmt/scenarios/country-tracker-analytics')){
      return Api.Visualizer
    } else if (
      url.includes("/gmt/scenarios/country-tracker-comparison-analytics")
    ) {
      return Api.Visualizer;
    }
    else if(url.includes('/gmt/scenarios/admin-rule-analytics')){
      return Api.Visualizer
    }
    else if (url.startsWith('/gmt')) {
      return Api.Spreadsheet;
    }
    return '';
  }

}

export class CbCApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.includes('/cbc/analytics/report-view')) {
      return Api.FileStoreApi;
    } else if (url.includes('/cbc/analytics')) {
      return Api.Visualizer;
    } else if (url.startsWith('/cbc/compliance')) {
      return Api.DueDateTracker;
    } else if (url.startsWith('/cbc/filing')) {
      return Api.DueDateTracker;
    }else if (url.startsWith('/cbc/scenarios/import-entity-data')) {
      return Api.EntityChart;
    }else if (url.includes('/cbc/library/exchange')) {
      return Api.Chapters;
    }else if (url.startsWith('/cbc')) {
      return Api.Spreadsheet;
    }
    return '';
  }
}

export class PCbCApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.includes('/pcbc/analytics/report-view')) {
      return Api.FileStoreApi;
    } else if (url.includes('/pcbc/analytics')) {
      return Api.Visualizer;
    } else if (url.startsWith('/pcbc/compliance')) {
      return Api.DueDateTracker;
    } else if (url.startsWith('/pcbc/filing')) {
      return Api.DueDateTracker;
    }else if (url.startsWith('/pcbc/scenarios/import-entity-data')) {
      return Api.EntityChart;
    }else if (url.startsWith('/pcbc')) {
      return Api.Spreadsheet;
    }
    return '';
  }
}

export class ItcApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.includes('/itc/analytics/report-view')) {
      return Api.FileStoreApi;
    } else if (url.includes('/itc/analytics')) {
      return Api.Visualizer;
    } else if (url.startsWith('/itc')) {
      return Api.Spreadsheet;
    }
    return '';
  }

}
export class TaxProvisionApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.includes('/txp/analytics/report-view')) {
      return Api.FileStoreApi;
    } else if (url.includes('/txp/analytics')) {
      return Api.Visualizer;
    } else if (url.startsWith('/txp')) {
      return Api.Spreadsheet;
    }
    return '';
  }

}

export class DashboardApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.includes('/dashboard/gmt')) {
      return Api.Visualizer;
    }

    return '';
  }
}
